export default __webpack_public_path__ + "static/media/2.81b79731.mp3";